import { LightMode, Nightlight } from "@mui/icons-material";
import { Box, Rating, Typography } from "@mui/material";
import { selectStoreDetail } from "features/searchStore/saga/searchStoreSlice";
import { useAppSelector } from "redux/hooks";

export function MOverviewSection() {
  const storeData = useAppSelector(selectStoreDetail);
  return (
    <Box display="flex" flexDirection="column" p={1} bgcolor="white">
      <Box display="flex" alignItems="center">
        <Rating size="small" value={storeData.Points.avg} readOnly />
        <Typography variant="h5" fontWeight="bold" sx={{ mx: 1 }}>
          {storeData.Points.avg.toString()}
        </Typography>

        <Typography variant="body2" sx={{ mx: 1 }}>
          {storeData.ReviewCount.toString()}<span>件</span>
        </Typography>
      </Box>

      <Box display="flex" alignItems="center" my={1}>
        {storeData.Budgets.day && storeData.Budgets.day.min && (
          <Box
            display="flex"
            alignItems="center"
            width="max-content"
            marginRight={1}
          >
            <LightMode
              fontSize="small"
              style={{ color: "#af9b65" }}
            />
            <Typography variant="body2">{`￥${storeData.Budgets.day.min} ~ ￥${storeData.Budgets.day.max}`}</Typography>
          </Box>
        )}

        {storeData.Budgets.night && storeData.Budgets.night.min && (
          <Box display="flex" alignItems="center" width="max-content" >
            <Nightlight fontSize="small" style={{ color: "#af9b65" }} />
            <Typography variant="body2">{`￥${storeData.Budgets.night.min} ~ ￥${storeData.Budgets.night.max}`}</Typography>
          </Box>
        )}
      </Box>
    </Box>
  );
}
